import ADACampusMap from "./ADACampusMap";

export default ADACampusMap;
